import React, { lazy, Suspense, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import withAdminLayout from '../layout/withAdminLayout';
import { getItem } from '../utility/localStorageControl';
// Zamówienia
// const Orders = lazy(() => import('../container/orders/Orders'));
const OrderPage = lazy(() => import('../container/orders/OrderPage'));
// Domeny
const Domains = lazy(() => import('../container/domains/Domains'));
const DomainsCreate = lazy(() => import('../container/domains/create/'));
const DomainsRenew = lazy(() => import('../container/domains/renew/'));
const DomainsTransfer = lazy(() => import('../container/domains/transfer/'));
const TransferDetailsPage = lazy(() => import('../container/domains/transfer/TransferDetailsPage'));
const DomainPage = lazy(() => import('../container/domains/DomainPage'));
const ManageDnsRecords = lazy(() => import('../container/domains/dns/ManageDnsRecords'));
const DomainInterceptionActiveOrders = lazy(() => import('../container/domains/interceptions/ActiveOrders'));
const DomainInterceptionExpiringDomains = lazy(() => import('../container/domains/interceptions/ExpiringDomains'));
const DomainInterceptionConfirmationPage = lazy(() => import('../container/domains/interceptions/ConfirmationPage'));
const Pricing = lazy(() => import('../container/pricing/Pricing'));
// Kontakty
const Contacts = lazy(() => import('../container/contacts/Contacts'));
// Tagi
const Tags = lazy(() => import('../container/tags/Tags'));
// Aukcje
const Auctions = lazy(() => import('../container/auctions/Auctions'));
// Opcje na domeny
const Futures = lazy(() => import('../container/futures/Futures'));
const FuturePage = lazy(() => import('../container/futures/FuturePage'));
const FuturesCreate = lazy(() => import('../container/futures/create/'));

const NotFound = lazy(() => import('../container/pages/404'));

const AccessBlocked = lazy(() => import('../container/pages/AccessBlocked'));

const AccountTwoFactorAuthenticate = lazy(() => import('../container/account/AccountTwoFactorAuthenticate'));
const Account = lazy(() => import('../container/account/Account'));
const MyProfile = lazy(() => import('../container/profile/settings/Settings'));
const HelpPage = lazy(() => import('../container/help/Help'));
const ApiKeys = lazy(() => import('../container/apiKeys/ApiKeysPage'));
const Topups = lazy(() => import('../container/balances/Topups'));
const Transaction = lazy(() => import('../container/balances/Transaction'));

const Payment = lazy(() => import('../container/payments/PaymentPage'));


const AftermarketIntegration = lazy(() => import('../container/aftermarket/Integration'));

const Panel = React.memo(() => {
  const { pathname } = useLocation();
  const userData = getItem('user_data');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="spin flex items-center justify-center bg-white dark:bg-dark h-screen w-full fixed z-[999] ltr:left-0 rtl:right-0 top-0">
          <Spin />
        </div>
      }
    >
      <Routes>
        {/* Domeny */}
        <Route path="domains/:nanoId/:domainName" element={<DomainPage />} />
        <Route path="domains/create/*" element={<DomainsCreate />} />
        <Route path="domains/renew/*" element={<DomainsRenew />} />
        <Route path="domains/transfer/*" element={<DomainsTransfer />} />
        <Route path="/domains/transfers/:nanoId" element={<TransferDetailsPage />} />
        <Route path="interceptions/domains" element={<DomainInterceptionActiveOrders />} />
        <Route path="interceptions/domains/expiring" element={<DomainInterceptionExpiringDomains />} />
        <Route path="/interceptions/confirmation/:operationId" element={<DomainInterceptionConfirmationPage />} />
        <Route path="/zones/:zoneId/:domainName" element={<ManageDnsRecords />} />
        <Route path="domains" element={<Domains />} />
        {/* Cennik */}
        <Route path="pricing" element={<Pricing />} />
        {/* Kontakty */}
        <Route path="contacts" element={<Contacts />} />
        {/* Tagi */}
        <Route path="tags" element={<Tags />} />
        {/* Aukcje */}
        <Route path="auctions" element={<Auctions />} />
        {/* Zamówienia */}
        {/* <Route path="orders" element={<Orders />} /> */}
        <Route path="orders/:nanoId" element={<OrderPage />} />
        <Route path="futures" element={<Futures />} />
        <Route path="futures/create/*" element={<FuturesCreate />} />
        <Route path="/futures/:futureId/:domainName" element={<FuturePage />} />
        <Route path="account/2fa" element={<AccountTwoFactorAuthenticate />} />
        <Route path="account/*" element={<Account />} />
        <Route path="profile/*" element={<MyProfile />} />
        <Route path="help" element={<HelpPage />} />
        <Route path="403" element={<AccessBlocked />} />
        <Route path="*" element={<NotFound />} />

        {/* Płatności */}
        <Route path="payment/:payableType/:payableId" element={<Payment />} />

        <Route path="/api-keys" element={<ApiKeys />} />
        {/* Zasilenia  */}
        <Route path="balances/topups" element={<Topups />} />
        <Route path="balances/transactions" element={<Transaction />} />

        {/* Aftermarket Integration */}
        <Route path="aftermarket/integration" element={<AftermarketIntegration />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Panel);
